"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Control = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _Search = _interopRequireDefault(require("@lt/components/icons-react/rebrand/Search"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../constants");

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Control = function Control(_ref) {
  var _value$destination;

  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var getValue = props.getValue,
      hasValue = props.hasValue,
      selectProps = props.selectProps;

  var _ref2 = getValue(),
      _ref3 = _slicedToArray(_ref2, 1),
      value = _ref3[0];

  var visa = value && 'destination' in value ? (_value$destination = value.destination) === null || _value$destination === void 0 ? void 0 : _value$destination.visa : value === null || value === void 0 ? void 0 : value.visa;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Control, props, /*#__PURE__*/_react["default"].createElement(SearchIcon, {
    className: "".concat(_constants.destinationPickerName, "__icon-search"),
    $highlighted: hasValue || !!selectProps.inputValue
  }), children, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(_constants.destinationPickerName, "__control-visa")
  }, visa));
};

exports.Control = Control;
var SearchIcon = (0, _styledComponents["default"])(_Search["default"]).withConfig({
  displayName: "Control__SearchIcon",
  componentId: "sc-1xvwnfz-0"
})(["height:16px;", ""], function (_ref4) {
  var $highlighted = _ref4.$highlighted;
  return !$highlighted && '& > path { fill: var(--grey2); }';
});